<div class="zen-main-container flex flex-row items-stretch min-h-screen" *ngIf="tenant.setup"
  (click)="logData(selectedEntity)">
  <div class="flex flex-col w-80 min-w-80 min-h-screen-70  gap-5  shadow-inner overflow-x-hidden relative">
    <div
      class="fixed w-inherit h-inherit flex flex-col gap-12 max-h-screen-70 innerListScroll min-h-screen-70 bg-opacity-5 bg-zen pt-20">
      <h6 [@child10] class="text-xs text-zen text-opacity-50 uppercase px-8">
        {{ "txt_emp_ex_settings" | translate: language:ModuleNames.Common }}
      </h6>
      <div class="flex flex-col">
        <ng-container *ngFor="let button of (user.role == UserRoles.SuperAdmin ? menu: (menu|slice:2:10))">
          <menu-button (click)="tabChange(button.index)"
            [icon]="tab == button.index? 'text-exp ' + button.icon: 'opacity-50 '+ button.icon"
            [active]="tab == button.index">
            {{ button.name | translate: language:ModuleNames.Common }}
          </menu-button>
        </ng-container>

      </div>
    </div>
  </div>
  <div class="flex flex-col w-full border-zen-light border-opacity-20 zen-main-container px-10 pt-14">
    <ng-container *ngIf="user.role == UserRoles.SuperAdmin">
      <div *ngIf="tab == 0">
        <companies-settings [companies]="companies" [companiesOptions]="CompaniesOptions"
          [companySizesList]="companySizesList" [language]="language" (addCompany)="newCompanyInitiate()"
          (editCompany)="editCompanyObject($event.index, $event.company)">
        </companies-settings>
      </div>

      <!-- users -->
      <div *ngIf="tab == 1">
        <users-settings [users]="users" [companies]="companies" [currentUser]="user" [usersOptions]="usersOptions"
          [language]="language" (addUser)="newUserInitiate(); selectedUserRole = UserRoles.Admin"
          (editUser)="editUser($event.user, $event.index)" (changePassword)="changePassword($event)"
          (changeEmail)="changeEmail($event)" (resetPassword)="resetPassword($event.email)"
          (deactivateUser)="deleteUser($event)" (activateUser)="activateUser($event)">
        </users-settings>
      </div>
    </ng-container>

    <div *ngIf="tab == 2">
      <company-structure-settings [selectedEntity]="selectedEntity" [entitiesOptions]="entitiesOptions"
        [language]="language" (addEntityGroup)="editEntityGroup()" (editEntityGroup)="editEntityGroup($event)"
        (deleteEntityGroup)="deleteStructure($event.entityGroup, $event.index)">
      </company-structure-settings>
    </div>

    <div *ngIf="tab == 3">
      <performance-rate-settings [selectedEntity]="selectedEntity" [performanceOptions]="performanceOptions"
        [language]="language" (addPerformance)="newPerformanceInitiate()"
        (editPerformance)="editPerformanceObject($event.index, $event.item)"
        (deletePerformance)="deletePerformance($event.item, $event.index)">
      </performance-rate-settings>
    </div>
    <div *ngIf="tab == 4">
      <band-level-settings [selectedEntity]="selectedEntity" [bandOptions]="bandOptions" [language]="language"
        (addBandLevel)="newBandInitiate()" (editBandLevel)="editBandLevelObject($event.index, $event.item)"
        (deleteBandLevel)="deleteBandLevel($event.item, $event.index)">
      </band-level-settings>
    </div>
    <div *ngIf="tab == 5">
      <job-grade-settings [selectedEntity]="selectedEntity" [jobOptions]="jobOptions" [language]="language"
        (addJobGrade)="newJobGradeInitiate()" (editJobGrade)="editJobGradeObject($event.index, $event.item)"
        (deleteJobGrade)="deleteJobGrade($event.item, $event.index)">
      </job-grade-settings>
    </div>
    <div [@slidesAniamtion]="resolveRoute(tab)" *ngIf="tab == 6">
      <select-criteria [softDelete]="true" [selection]="false" [(modal)]="criteriaModal" [language]="language"
        [selectedEntity]="selectedEntity" [matrixList]="selectedEntity.metrics"
        [engagementMetrics]="selectedEntity.metrics"
        (updateEngagementMetrics)="$event.tKey >= 0?updateEngagementMetrics($event.metric, $event.tKey):updateEngagementMetrics($event)">
        <ng-container head>
          <div class="flex flex-row items-center justify-between pb-8">
            <h5 [@first] class="text-zen font-medium text-3xl">
              {{"txtExtraCriteria"|
              translate:language:ModuleNames.Common}}
            </h5>
            <a (click)="criteriaModal = true" class="btn exp uppercase leading-12 h-12 block rounded px-5">
              {{"txt_new_criteria"| translate:language:ModuleNames.Shared}}</a>
          </div>

        </ng-container>

      </select-criteria>

    </div>
    <div [@slidesAniamtion]="resolveRoute(tab)" *ngIf="tab == 7">
      <h5 [@first] class="text-zen font-medium text-3xl">
        {{ "txtIntegration" | translate: language:ModuleNames.Common }}
      </h5>
      <div class="flex flex-row flex-wrap my-8 py-5">
        <!-- <div
          class="p-7 mb-2 rounded-md group hover:bg-white hover:shadow-md transition-all 2xl:w-1/3 w-1/2 cursor-pointer"
          (click)="integrationModal = true">
          <div class="flex flex-row gap-5 items-center">
            <img [@child3]
              class="h-20 w-20 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
              src="assets/img/svg/thomas.svg" alt="" />
            <div>
              <h5 [@child4] class="text-xl font-bold text-zen">
                {{
                "Thomas International"| translate: language:ModuleNames.Common
                }}
              </h5>
              <h5 [@child5] class="text-xxs font-normal text-zen mt-1">
                {{
                "TALENT ASSESSMENT" | translate: language:ModuleNames.Common
                }}
              </h5>
            </div>
          </div>
          <p [@child6] class="text-xs text-zen my-5">
            {{ "Harness the power of psychology and machine learning with the Thomas talent assessment platform. Make
            smarter recruitment and development decisions." | translate: language:ModuleNames.Common }}
          </p>
          <div class="flex flex-row justify-end" *ngIf="tenant.thomasIntegrated">
            <p [@child4] class="text-zen-green text-xs font-medium">
              <i class="fal fa-check-circle"></i>
              {{ "Integrated" | translate: language:ModuleNames.Common }}
            </p>
          </div>
        </div> -->

        <div
          class="p-7 mb-2 rounded-md group hover:bg-white hover:shadow-md transition-all 2xl:w-1/3 w-1/2 cursor-pointer"
          (click)="excelIntegration = true">
          <div class="flex flex-row gap-5 items-center">
            <img [@child3]
              class="h-20 w-20 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
              src="assets/img/excel.png" alt="" style="object-fit: cover" />
            <div>
              <h5 [@child4] class="text-xl font-bold text-zen">
                {{
                "Excel Integration"
                | translate: language:ModuleNames.Common
                }}
              </h5>
              <h5 [@child5] class="text-xxs font-normal text-zen mt-1">
                Zenithr
              </h5>
            </div>
          </div>
          <p [@child6] class="text-xs text-zen my-5">
            {{
            "Harness the simplicity of integrating your data using Microsoft Excel"
            | translate: language:ModuleNames.Common
            }}
          </p>
          <div class="flex flex-row justify-end" *ngIf="selectedEntity.DataIntegrated">
            <p [@child4] class="text-zen-green text-xs font-medium">
              <i class="fal fa-check-circle"></i>
              {{ "Integrated" | translate: language:ModuleNames.Common }}
            </p>
          </div>
        </div>

        <!-- <div
      class="p-7 mb-2 rounded-md group hover:bg-white hover:shadow-md transition-all 2xl:w-1/3 w-1/2 cursor-pointer"
      (click)="excelIntegration = true">
      <div class="flex flex-row gap-5 items-center">
        <img [@child3]
          class="h-20 w-20 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
          src="assets/img/WhatsappB.png" alt="" style="object-fit: cover;">
        <div>
          <h5 [@child4] class="text-xl font-bold text-zen">WhatsApp Integration</h5>
          <h5 [@child5] class="text-xxs font-normal text-zen mt-1">WhatsApp By Meta</h5>
        </div>
      </div>
      <p [@child6] class="text-xs text-zen my-5">Integrate your WhatsApp API and Secret and send your surveys on Whatsapp</p>
    </div> -->
      </div>
    </div>
    <div [@slidesAniamtion]="resolveRoute(tab)" *ngIf="tab == 8">
      <!-- Notifications -->
      <!-- <h5 class="text-zen">{{ txtNotificationSettings }}</h5> -->
      <h5 [@first] class="text-zen font-medium text-3xl">
        {{
        "txt_notification_settings" | translate: language:ModuleNames.Common
        }}
      </h5>
      <div class="my-8 py-5">

        <div class="flex flex-row gap-4 w-full exp">
          <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
            <h5 [@child8] class="m-0">
              {{
              "txt_notification_remaining_units"
              | translate: language:ModuleNames.Common
              }}
            </h5>
            <z-toggle [@child10] (ngModelChange)="updateUserEntities(user)" [(ngModel)]="user.remainingUnits">
            </z-toggle>
          </div>
          <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
            <h5 [@child10] class="m-0">
              {{
              "txt_notification_subscription_expiring"
              | translate: language:ModuleNames.Common
              }}
            </h5>
            <z-toggle [@child12] (ngModelChange)="updateUserEntities(user)" [(ngModel)]="user.subscriptionExpiring">
            </z-toggle>
          </div>
        </div>
        <div class="flex flex-row gap-4 w-full exp">
          <div class="flex flex-row md:w-1/2 w-full justify-between items-center bg-white rounded py-3 px-4 mb-4">
            <h5 [@child10] class="m-0">
              {{
              "txt_notification_subscription_expired"
              | translate: language:ModuleNames.Common
              }}
            </h5>
            <z-toggle [@child12] (ngModelChange)="updateUserEntities(user)" [(ngModel)]="user.subscriptionExpired">
            </z-toggle>
          </div>
          <span class="w-1/2"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<z-modal *ngIf="companyAdd" [(open)]="companyAdd">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center">
      <i class="fal fa-book text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
      <h4 class="text-2xl font-bold text-zen">
        {{
        editMode
        ? extractNameLanguage(newCompany.name)
        : ("txt_modal_company" | translate: language:ModuleNames.Common)
        }}
      </h4>
    </div>
  </ng-container>

  <ng-container body>
    <div class="flex flex-col gap-5">
      <z-translation-input [invalid]="companyInvalid" [maxCount]="mdCount" [required]="true"
        [label]="'txt_company_name' | translate: language:ModuleNames.Common" [language]="language"
        [supportedLanguages]="selectedEntity.ContentLanguages" [(ngModel)]="newCompany.name"></z-translation-input>

      <div class="flex flex-row justify-between items-center gap-2 w-full">
        <div class="w-full flex flex-col">
          <z-select [invalid]="companyInvalid" [required]="true" [color]="'exp'" [(ngModel)]="newCompany.companySize"
            [label]="
              'txt_company_size' | translate: language:ModuleNames.Common
            " [options]="companySizesList" [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.name }}
            </ng-template>
          </z-select>
        </div>
        <div class="w-full flex flex-col">
          <z-select [invalid]="companyInvalid" [required]="true" [color]="'exp'" [(ngModel)]="newCompany.industry"
            [label]="
              'txt_company_industry' | translate: language:ModuleNames.Common
            " [options]="industriesList" [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.name }}
            </ng-template>
          </z-select>
        </div>
      </div>
      <div class="flex flex-row justify-between items-center gap-2 w-full mb-2">
        <div class="w-1/2">
          <!-- <custom-dropdown *ngIf="!resetDropdown" class="customDropDown" [txtBranches]="txtHeadQuarter"
            [selectionMode]="'Single'" [dropDownData]="countriesList" [selectedKey]="newCompany.headQuarter"
            (selectionChanged)="dropDownChanged($event, newCompany)">
          </custom-dropdown> -->

          <z-select [color]="'exp'" [(ngModel)]="newCompany.headQuarter"
            (selectionChanged)="dropDownChanged($event, newCompany)"
            [label]="'txtHeadQuarter' | translate: language:ModuleNames.Common" [options]="originalCountriesList"
            [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.name | extract: language }}
            </ng-template>
          </z-select>
        </div>
        <div class="w-1/2">
          <z-select [invalid]="companyInvalid" [required]="true" [color]="'exp'" [multiple]="true"
            [(ngModel)]="newCompany.Branches" (selectionChanged)="branchesSelectionChanged($event, newCompany)"
            [label]="'txt_branches' | translate: language:ModuleNames.Common" [options]="originalCountriesList"
            [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.name | extract: language }}
            </ng-template>
          </z-select>

          <!-- <span *ngIf="!resetDropdown" [matTooltip]="txtFieldIsRequired" [matTooltipClass]="'toolTipAlert'"
            [matTooltipDisabled]="!vCompanyBranches" [className]="vCompanyBranches? ' alertLine' : '' ">
            <custom-dropdown class="customDropDown" [txtBranches]="txtBranches" [selectionMode]="'Multi'"
              [dropDownData]="countriesList" [selectedOptions]="newCompany.Branches"
              (selectionChanged)="branchesSelectionChanged($event, newCompany)">
            </custom-dropdown>
          </span> -->
        </div>
      </div>
      <div class="flex flex-row justify-between items-center gap-2 w-full mb-2">
        <div class="w-1/2">
          <z-select [invalid]="companyInvalid" [required]="true" [color]="'exp'" [multiple]="true"
            [(ngModel)]="newCompany.ContentLanguages" [label]="
              'txt_content_languages' | translate: language:ModuleNames.Common
            " [options]="supportedLanguages" [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.name }}
            </ng-template>
          </z-select>
        </div>

        <div class="w-1/2">
          <z-select [invalid]="companyInvalid" [required]="true" [color]="'exp'" [(ngModel)]="newCompany.contactCode"
            [label]="
              'txt_country_code' | translate: language:ModuleNames.Common
            " [options]="originalCountriesList" [language]="language">
            <ng-template #valueTemplate let-value>
              {{ value?.countryCode }}
            </ng-template>
            <ng-template #optionTemplate let-option>
              {{ option?.name | extract: language }}
              {{ "(" + option?.countryCode + ")" }}
            </ng-template>
          </z-select>
        </div>
      </div>
      <div class="flex flex-row justify-between items-center gap-2 w-full">
        <div class="w-full flex flex-col">
          <z-input [invalid]="companyInvalid" [required]="true" [language]="language" [label]="
              'txt_contact_number' | translate: language:ModuleNames.Common
            " [disabled]="countWord(newCompany.contactNumber, mdCount) > mdCount" [maxlength]="mdCount" [number]="true"
            [(ngModel)]="newCompany.contactNumber"></z-input>

          <!-- <div class="bg-white rounded-md px-5 pt-1 overflow-hidden h-15">
            <mat-form-field class="w-full" appearance="none">
              <mat-label>{{ txtContactNumber }}</mat-label>
              <input #number="ngModel" matInput [maxlength]="mdCount" [disabled]="countWord(newCompany.contactNumber,
          mdCount) > mdCount " [(ngModel)]="newCompany.contactNumber">
            </mat-form-field>
          </div>
          <div *ngIf="number.invalid && (number.dirty || number.touched)"
            class="alert alert-danger transform translate-y-1">
            <div class="text-red-600 text-xs" *ngIf="number.errors.required">
              {{ txtFieldIsRequired }}
            </div>
          </div> -->
        </div>
        <div class="w-full flex flex-col">
          <z-input [language]="language" [label]="'txtWebsite' | translate: language:ModuleNames.Common"
            [maxlength]="mdCount" [(ngModel)]="newCompany.website"></z-input>
        </div>
      </div>

      <span [matTooltip]="
          'txt_required_field' | translate: language:ModuleNames.Common
        " [matTooltipClass]="'toolTipAlert'" [matTooltipDisabled]="!vLogo" [className]="vLogo ? ' alertLine' : ''">
        <div class="flex flex-row justify-between items-center w-full bg-zen bg-opacity-5 h-18 px-5 rounded">
          <img *ngIf="newCompany.logoURL" [src]="newCompany.logoURL"
            style="height: 45px; object-fit: cover; object-position: left" />
          <h5 *ngIf="!newCompany.logoURL" class="opacity-50 text-2xl uppercase">
            {{ "txtLogo" | translate: language:ModuleNames.Common }}
          </h5>
          <a class="btn cancel px-5 py-2 rounded-md cursor-pointer">
            {{ "btn_upload" | translate: language:ModuleNames.Common
            }}<input class="uploadInput cursor-pointer" id="fileselect"
              accept="image/x-png,image/gif,image/jpeg, image/jpg" (change)="selectFile($event, newCompany)"
              type="file" /></a>
        </div>
      </span>
    </div>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('companyAdd')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <button [disabled]="uploading" (click)="editMode ? updateCompany(newCompany) : createCompany()"
      class="btn exp w-auto text-center align-middle rounded-md px-8 py-4">
      <span class="mx-1">{{
        (editMode ? "btn_update" : "btn_company_add")
        | translate: language:ModuleNames.Common
        }}</span>
    </button>
  </ng-container>
</z-modal>

<!-- user Modal -->





<z-modal *ngIf="userAdd" [open]="userAdd" [autoWidth]="true">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center">
      <div class="w-6 h-6 flex justify-center items-center">
        <i class="fa-regular fa-users text-zen-neutralp60 text-xl"></i>
      </div>
      <h4 class="text-lg font-medium text-zen">
        {{
        editMode
        ? newUser.firstName + " " + newUser.lastName
        : ("txt_modal_user" | translate: language:ModuleNames.Common)
        }}
      </h4>
    </div>
  </ng-container>
  <ng-container body>
    <div class="flex flex-col gap-6 w-[75rem]">
      <p class="text-zen text-sm font-medium">{{'txtAccountDetails' | translate: language:ModuleNames.Common}}</p>
      <div class="flex flex-row gap-6">
        <div class="w-full flex flex-col">
          <z-input [invalid]="userInvalid" [required]="true" [language]="language" [label]="
              'txt_user_firstName' | translate: language:ModuleNames.Common
            " [disabled]="countWord(newUser.firstName, mdCount) > mdCount" [maxlength]="mdCount"
            [(ngModel)]="newUser.firstName"></z-input>
        </div>
        <div class="w-full flex flex-col">
          <z-input [invalid]="userInvalid" [required]="true" [language]="language" [label]="
              'txt_user_lastName' | translate: language:ModuleNames.Common
            " [disabled]="countWord(newUser.lastName, mdCount) > mdCount" [maxlength]="mdCount"
            [(ngModel)]="newUser.lastName"></z-input>
        </div>
      </div>
      <div class="flex flex-row gap-2">
        <div class="w-full flex flex-col">
          <z-input [email]="true" [invalid]="userInvalid" [required]="true" [language]="language"
            [label]="'txt_user_email' | translate: language:ModuleNames.Common"
            [disabled]="countWord(newUser.email, mdCount) > mdCount || editMode" [maxlength]="mdCount"
            [(ngModel)]="newUser.email">
          </z-input>
        </div>
        <div class="w-full flex flex-row gap-1" *ngIf="!editMode">
          <z-input class="w-full" [password]="true" [invalid]="userInvalid" [required]="true" [language]="language"
            [label]="'txtPassword' | translate: language:ModuleNames.Common"
            [disabled]="countWord(newUser.email, mdCount) > mdCount" [maxlength]="mdCount"
            [(ngModel)]="newUser.password"></z-input>
          <a (click)="generatePassword()"
            class="btn h-9 leading-9 py-0 px-1 cancel mt-6  whitespace-nowrap rounded-sm">{{'GeneratePassword' |
            translate:language:ModuleNames.Shared}}</a>
          <a *ngIf="generatedPassword" (click)="copyPassword()"
            class="btn h-9 leading-9 py-0 px-1 cancel mt-6 whitespace-nowrap rounded-sm">{{'CopyPassword' |
            translate:language:ModuleNames.Share}}</a>
        </div>
      </div>



      <div class="flex flex-row h-8 w-full gap-2 items-center px-2 rounded bg-zen/10">
        <div class="w-5 h-5 flex justify-center items-center text-zen text-base">
          <i class="fa-regular fa-info-circle"></i>
        </div>
        <p class="text-zen text-xs">{{'txt_Thispassw_546' | translate: language:ModuleNames.Common}}</p>
      </div>
      <p class="text-sm text-zen font-medium mt-4">{{'txt_UserRole_696' | translate: language:ModuleNames.Common}}</p>
      <div class="flex flex-row w-full items-stretch gap-4">
        @for (role of userRolesList; track $index) {
        @let isRoleSelected = role == selectedUserRole;
        <div class="flex flex-col gap-4 p-6 items-stretch w-full bg-white rounded btn"
          [ngClass]="isRoleSelected ? 'border-exp border-[3px]':'border border-zen-neutralp90 m-0.5'"
          (click)="selectRole(role)">
          <div class="flex flex-row gap-2 items-center">
            <div class="w-5 h-5 rounded-full border flex justify-center items-center"
              [ngClass]="isRoleSelected ? 'border-exp':'border-zen-neutralp90'">
              <div class="w-2 h-2 rounded-full bg-exp transition-all duration-200 ease-expo"
                [ngClass]="isRoleSelected ? 'opacity-100':'opacity-0'"></div>
            </div>
            <p class="text-zen font-medium text-sm">{{role | translate: language:ModuleNames.Common}}</p>
          </div>
          <p class="text-zen-primaryLight text-xs">{{('SUB_'+role) | translate: language:ModuleNames.Common}}</p>
        </div>
        }
      </div>
    </div>
    <!-- {{selectedUserRole}} -->
    <!-- User Company Permissions Tree Component -->
    <company-tree *ngIf="selectedUserRole !== UserRoles.SuperAdmin" [selectedUserRole]="selectedUserRole"
      [allEntities]="allEntities" [permissions]="newUser.CompanyPermissions" [language]="language">
    </company-tree>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('userAdd'); editMode = false"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <button [disabled]="isSavingUser" (click)="editMode ? updateUser(newUser) : createNewUser()"
      class="btn exp w-auto text-center align-middle rounded-md px-8 py-4">
      <span class="mx-1">{{
        (editMode ? "btn_update" : "btn_add_user")
        | translate: language:ModuleNames.Common
        }}</span>
    </button>
  </ng-container>
</z-modal>

<!-- add performance -->

<z-modal *ngIf="performanceAdd" [open]="performanceAdd">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center">
      <i class="fal fa-analytics text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
      <h4 class="text-2xl font-bold text-zen">
        {{ "btn_performance_add" | translate: language:ModuleNames.Common }}
      </h4>
      <!-- <p class="text-sm text-zen">Please reupload the data file after fixing the validation errors.</p> -->
    </div>
  </ng-container>
  <ng-container body>
    <div class="flex flex-row gap-2 mb-5">
      <div class="w-9/12 flex flex-col">
        <z-input [invalid]="performanceInvalid" [required]="true" [language]="language" [label]="
            'txt_performance_rate_value'
              | translate: language:ModuleNames.Common
          " [disabled]="countWord(newPerformanceRate.value, mdCount) > mdCount" [maxlength]="mdCount"
          [(ngModel)]="newPerformanceRate.value"></z-input>

        <!-- <div class="bg-white rounded-md px-5 pt-1 overflow-hidden h-15">
          <mat-form-field class="w-full" appearance="none">
            <mat-label>{{"txt_performance_rate_value"| translate:language:ModuleNames.Common }}</mat-label>
            <input #rate="ngModel" required matInput type="text" [maxlength]="mdCount" [disabled]="countWord(newPerformanceRate.value,
              mdCount) > mdCount " [(ngModel)]="newPerformanceRate.value">
          </mat-form-field>
        </div>
        <div *ngIf="rate.invalid && (rate.dirty || rate.touched)" class="alert alert-danger transform translate-y-1">
          <div class="text-red-600 text-xs" *ngIf="rate.errors.required">
            {{ 'txt_required_field'| translate:language:ModuleNames.Common }}
          </div>
        </div> -->
      </div>
      <div class="w-3/12 flex flex-col">
        <z-select [color]="'exp'" [(ngModel)]="newPerformanceRate.icon" [label]="
            'txt_performance_icon' | translate: language:ModuleNames.Common
          " [key]="'value'" [options]="performanceColors" [language]="language">
          <ng-template #valueTemplate let-value>
            <fa-icon [icon]="faStar" [ngStyle]="{ color: newPerformanceRate.icon }"></fa-icon>
          </ng-template>
          <ng-template #optionTemplate let-value>
            <fa-icon [icon]="faStar" [ngStyle]="{ color: value?.value }"></fa-icon>
          </ng-template>
        </z-select>

        <!-- <div class="bg-white rounded-md px-5 pt-1 overflow-hidden h-15">
          <mat-form-field class="w-full" appearance="none">
            <mat-label>{{"txt_performance_icon"| translate:language:ModuleNames.Common }}</mat-label>
            <mat-select-trigger *ngIf="newPerformanceRate.icon">
              <fa-icon class="h-15" [icon]="faStar" [ngStyle]="{ color: newPerformanceRate.icon }"></fa-icon>
            </mat-select-trigger>
            <mat-select #icon="ngModel" [(ngModel)]="newPerformanceRate.icon">
              <mat-option *ngFor="let icon of performanceColors" [value]="icon">
                <fa-icon [icon]="faStar" [ngStyle]="{ color: icon }"></fa-icon>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="icon.invalid && (icon.dirty || icon.touched)" class="alert alert-danger transform translate-y-1">
          <div class="text-red-600 text-xs" *ngIf="icon.errors.required">
            {{ 'txt_required_field'| translate:language:ModuleNames.Common }}
          </div>
        </div> -->
      </div>
    </div>
    <z-translation-input [invalid]="performanceInvalid" [maxCount]="mdCount" [required]="true" [label]="
        'txt_performance_rate_description'
          | translate: language:ModuleNames.Common
      " [language]="language" [supportedLanguages]="selectedEntity.ContentLanguages"
      [(ngModel)]="newPerformanceRate.description">
    </z-translation-input>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('performanceAdd')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <button (click)="
        editMode ? updatePerformance(newPerformanceRate) : addNewPerformance()
      " class="btn exp w-auto text-center align-middle rounded-md px-8 py-4">
      <span class="mx-1">{{
        (editMode ? "btn_update" : "btn_performance_add")
        | translate: language:ModuleNames.Common
        }}</span>
    </button>
  </ng-container>
</z-modal>

<!-- add band -->
<z-modal *ngIf="bandLevelAdd" [open]="bandLevelAdd">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center">
      <i
        class="fal fa-user-chart text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
      <h4 class="text-2xl font-bold text-zen">
        {{
        (editMode ? "txt_bandlevel" : "txt_modal_band")
        | translate: language:ModuleNames.Common
        }}
      </h4>
      <!-- <p class="text-sm text-zen">Please reupload the data file after fixing the validation errors.</p> -->
    </div>
  </ng-container>
  <ng-container body>
    <z-translation-input [invalid]="bandlevelInvalid" [maxCount]="mdCount" [required]="true"
      [label]="'txt_band_level_name' | translate: language:ModuleNames.Common" [language]="language"
      [supportedLanguages]="selectedEntity.ContentLanguages" [(ngModel)]="newBandLevel.name"></z-translation-input>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('bandLevelAdd')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <button (click)="editMode ? updateBandLevel(newBandLevel) : addNewBandLevel()"
      class="btn exp w-auto text-center align-middle rounded-md px-8 py-4">
      <span class="mx-1">{{
        (editMode ? "btn_update" : "btn_add_band_level")
        | translate: language:ModuleNames.Common
        }}</span>
    </button>
  </ng-container>
</z-modal>

<!-- add grade -->
<z-modal *ngIf="jobGradeAdd" [open]="jobGradeAdd">
  <ng-container header>
    <div class="flex flex-row gap-2 items-center">
      <i class="fal fa-award text-white bg-exp shadow-xl rounded-full h-10 w-10 text-xl text-center leading-10"></i>
      <h4 class="text-2xl font-bold text-zen">
        {{
        editMode
        ? extractNameLanguage(newJobGrade.name)
        : ("btn_add_job_grade" | translate: language:ModuleNames.Common)
        }}
      </h4>
      <!-- <p class="text-sm text-zen">Please reupload the data file after fixing the validation errors.</p> -->
    </div>
  </ng-container>
  <ng-container body>
    <div class="flex flex-row justify-between gap-2">
      <div class="flex flex-col w-1/2">
        <z-translation-input [invalid]="jobGradeInvalid" [maxCount]="mdCount" [required]="true"
          [label]="'txt_job_grade' | translate: language:ModuleNames.Common" [language]="language"
          [supportedLanguages]="selectedEntity.ContentLanguages" [(ngModel)]="newJobGrade.name"></z-translation-input>
      </div>
      <div class="flex flex-col w-1/2">
        <z-select [invalid]="jobGradeInvalid" [color]="'exp'" [(ngModel)]="newJobGrade.bandLevelKey"
          [label]="'txt_bandlevel' | translate: language:ModuleNames.Common" [options]="selectedEntity.BandLevels"
          [language]="language">
          <ng-template #valueTemplate let-value>
            {{ value?.name | extract: language }}
          </ng-template>
        </z-select>

        <!-- <div class="bg-white rounded-md px-5 pt-1 overflow-hidden h-15">
          <mat-form-field class="w-full" appearance="none">
            <mat-label>{{ 'txt_bandlevel'| translate:language:ModuleNames.Common }}</mat-label>
            <mat-select required #level="ngModel" [(ngModel)]="newJobGrade.bandLevelKey">
              <mat-option *ngFor="let bandLevel of selectedEntity.BandLevels" [value]="bandLevel.key">
                {{ extractNameLanguage(bandLevel.name) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="level.invalid && (level.dirty || level.touched)" class="alert alert-danger transform translate-y-1">
          <div class="text-red-600 text-xs" *ngIf="level.errors.required">
            {{ 'txt_required_field'| translate:language:ModuleNames.Common }}
          </div>
        </div> -->
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('jobGradeAdd')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <button (click)="editMode ? updateJobGrade(newJobGrade) : addNewJobGrade()"
      class="btn exp w-auto text-center align-middle rounded-md px-8 py-4">
      <span class="mx-1">{{
        (editMode ? "btn_update" : "btn_add_job_grade")
        | translate: language:ModuleNames.Common
        }}</span>
    </button>
  </ng-container>
</z-modal>

<!-- <z-modal *ngIf="integrationModal" [open]="integrationModal" [color]="'bg-exp'">
  <ng-container header>
    <div class="flex flex-row gap-5 items-center">
      <img
        class="h-18 w-18 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
        src="assets/img/svg/thomas.svg" alt="" />
      <div>
        <h5 class="text-xl font-bold text-zen">
          {{ "Thomas International" | translate: language:ModuleNames.Common }}
        </h5>
        <h5 class="text-xxs font-normal text-zen mt-1">
          {{ "TALENT ASSESSMENT" | translate: language:ModuleNames.Common }}
        </h5>
      </div>
    </div>
    <p class="text-xs text-zen my-5">
      {{
      "Harness the power of psychology and machine learning with the Thomas talent assessment platform.Make smarter
      recruitment and development decisions."
      | translate: language:ModuleNames.Common
      }}
    </p>
  </ng-container>
  <ng-container body>
    <div class="px125">
      <h5 class="c-60 is-size-55 font-normal">
        {{ "txtAccountDetails" | translate: language:ModuleNames.Common }}
      </h5>
      <div class="flex flex-row gap-5">
        <div class="w-1/2">
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>{{
              "txtClientID" | translate: language:ModuleNames.Common
              }}</mat-label>
            <input [(ngModel)]="thomasClientID" matInput type="text" />
          </mat-form-field>
        </div>
        <div class="w-1/2">
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>{{
              "txtPassword" | translate: language:ModuleNames.Common
              }}</mat-label>
            <input matInput [(ngModel)]="thomasClientSecret" [type]="hide ? 'password' : 'text'" />
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="txtHidepassword"
              [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
      <div class="flex flex-row justify-center mb-5">
        <a (click)="testThomasConnection()" class="btn cancel leading-10 px-7 rounded font-medium text-sm text-zen">{{
          "Test Connection" | translate: language:ModuleNames.Common }}</a>
      </div>
      <div *ngIf="startingAuthorization" class="bg-zen bg-opacity-10 rounded p-5 logBox">
        <h5 *ngIf="startingAuthorization" class="text-xxs text-zen">
          {{ "Testing connection..." | translate: language:ModuleNames.Common }}
        </h5>
        <h5 *ngIf="startingAuthorization" class="text-xxs text-zen">
          {{
          "Starting user authentication"
          | translate: language:ModuleNames.Common
          }}
        </h5>
        <h5 *ngIf="connectionWorked == 'SUCCESS'" class="text-xxs text-zen-green">
          {{ "User authenticated!" | translate: language:ModuleNames.Common }}
        </h5>
        <h5 *ngIf="connectionWorked == 'SUCCESS'" class="text-xxs text-zen-green">
          {{
          "Connection established!" | translate: language:ModuleNames.Common
          }}
        </h5>
        <h5 *ngIf="connectionWorked == 'ERROR'" class="text-xxs text-red-600 font-medium">
          {{ "Connection Failed!" | translate: language:ModuleNames.Common }}
        </h5>
      </div>
    </div>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('integrationModal')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <a *ngIf="connectionWorked == 'SUCCESS'" (click)="integrateThomas()"
      class="btn exp text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">
      {{ "INTEGRATE NOW" | translate: language:ModuleNames.Common }}
    </a>
  </ng-container>
</z-modal> -->

<z-modal *ngIf="excelIntegration" [open]="excelIntegration" [color]="'bg-exp'">
  <ng-container header>
    <div class="flex flex-row gap-5 items-center">
      <img
        class="h-18 w-18 block rounded bg-white shadow group-hover:shadow-none object-center object-none transition-all"
        src="assets/img/excel.png" alt="" style="object-fit: cover" />
      <div>
        <h5 class="text-xl font-bold text-zen">
          {{ "Excel Integration" | translate: language:ModuleNames.Common }}
        </h5>
        <h5 class="text-xxs font-normal text-zen mt-1 capitalize">Zenithr</h5>
      </div>
    </div>
    <p class="text-xs text-zen my-5">
      {{
      "Harness the simplicity of integrating your data using Microsoft Excel"
      | translate: language:ModuleNames.Common
      }}
    </p>
  </ng-container>
  <ng-container body>
    <ng-container>
      <div class="flex flex-row">
        <div class="flex flex-col w-2/3 gap-2">
          <h4 class="max-w-xs truncate text-sm text-zen">
            {{ "txt_step" | translate: language:ModuleNames.Shared }} 1:
          </h4>
          <p class="text-base">
            {{
            'Click "Download file" to download the premade spreadsheet (.xlsx).'
            | translate: language:ModuleNames.Common
            }}
          </p>
        </div>
        <div class="flex flex-col w-1/3 gap-2">
          <a (click)="downloadIntegrationExcel()" class="btn cancel px-5 rounded-md leading-12 text-center">
            <i class="fal leading-12 px-1 fa-download"></i>{{ "btn_download" | translate: language:ModuleNames.Shared
            }}</a>
        </div>
      </div>
      <br>
      <div class="flex flex-row">
        <div class="flex flex-col w-2/3 gap-2">
          <h4 class="max-w-xs truncate text-sm text-zen">
            {{ "txt_step" | translate: language:ModuleNames.Shared }} 2:
          </h4>
          <p class="text-base">
            {{
            "Fill out the premade template and share it with your Account Manager."
            | translate: language:ModuleNames.Common
            }}
          </p>
        </div>
        <div class="flex flex-col w-1/3 gap-2">
          <a class="btn exp px-5 rounded-md leading-12 text-center">
            <i class="fal leading-12 px-1 fa-upload"></i>{{'btn_upload_file'|
            translate:language:ModuleNames.Shared}}<input (change)="uploadIntegrationFile($event)" type="file"></a>
        </div>
      </div>


      <span class="text-zen font-medium text-lg  mt-5" *ngIf="excelErrors.length">Errors</span>
      <div class="flex flex-col max-h-32 overflow-auto w-full gap-1" *ngIf="excelErrors.length">

        <ng-container *ngFor="let excelError of excelErrors">
          <span class="text-zen-red" *ngIf="excelError.row != 0">Error at Column: {{ excelError.column }}, Row: {{
            excelError.row }} - {{ excelError.message }}</span>
          <span class="text-zen-red" *ngIf="excelError.row == 0">Error at Column: {{ excelError.column }} - {{
            excelError.message }}</span>
        </ng-container>


      </div>
      <!-- <div class="flex flex-row">
          <div class="flex flex-col w-2/3 gap-2">
              <h4 class="max-w-xs truncate text-sm text-zen">{{'txt_step'| translate:language:ModuleNames.Shared}} 3:
              </h4>
              <p class="text-base">{{'txt_step3'| translate:language:ModuleNames.Shared}}</p>
          </div>
          <div class="flex flex-col w-1/3 gap-2">
              <a class="btn exp px-5 rounded-md leading-12 text-center">
                  <i class="fal leading-12 px-1 fa-upload"></i>{{'btn_upload_file'| translate:language:ModuleNames.Shared}}<input
                      (change)="uploadFile($event)" type="file"></a>
          </div>
      </div> -->
    </ng-container>
  </ng-container>
  <ng-container footer>
    <a (click)="closeModal('excelIntegration')"
      class="btn cancel text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">{{ "btn_cancel" |
      translate: language:ModuleNames.Common }}</a>
    <a *ngIf="connectionWorked == 'SUCCESS'" (click)="integrateThomas()"
      class="btn exp text-center align-middle rounded-md px-8 py-4 uppercase text-lg font-medium">
      {{ "INTEGRATE NOW" | translate: language:ModuleNames.Common }}
    </a>
  </ng-container>
</z-modal>